import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import Modal from "react-bootstrap/Modal"
import Table from "react-bootstrap/Table"
import { toast } from "react-toastify"

import { selectTranslations } from "../../../services/i18n/i18nSlice"
import { fetchOfaNotifyUsers, fetchUsersOfaSubjects } from "../UsersApi"
import ConfirmModal from "../../../components/_modals/ConfirmModal"
import UserModal from "./UserModal"

import close_img from '../../../assets/images/close.svg'

const LIMIT = 50

export default function OfaOverviewModal ({show, onClose}) {

    const t = useSelector(selectTranslations)
    const [users, setUsers] = useState([])
    const [canLoadMore, setCanLoadMore] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [showConfirmNotify, setShowConfirmNotify] = useState(false)
    const [selectedUser, setSelectedUser] = useState(null)

    const loadUsers = async (skip = 0) => {
        setIsLoading(true)
        const response = await fetchUsersOfaSubjects({skip: skip, limit: LIMIT})
        if(response.success){
            setUsers(skip === 0 ? response.data : [...users, ...response.data])
            setCanLoadMore(response.data.length === LIMIT)
        } else {
            toast.error(response.error || t.error.error_loading)
        }
        setIsLoading(false)
    }

    const handleNotifyUsers = async () => {
        setShowConfirmNotify(false)
        const response = await fetchOfaNotifyUsers()
        if(response.success)
            toast.success(t.ofa.notify_success)
        else
            toast.error(response.error || t.ofa.notify_error)
    }

    useEffect(()=>{
        if(show)
            loadUsers()
    },[show])

    return (
        <>
        <Modal show={show} onHide={onClose} centered size={'xl'}>
            <Modal.Body>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h2 className="mb-0">{t.ofa.overview}</h2>
                    <div className="d-flex align-items-center">
                        <button className="secondary me-3" onClick={()=>setShowConfirmNotify(true)}>{t.ofa.notify_users}</button>
                        <img src={close_img} className="pointer" onClick={onClose} />
                    </div>
                </div>
                {users.length === 0 && !isLoading ?
                    <p className="text-muted">{t.ofa.no_users}</p> :
                    <Table hover responsive>
                        <thead>
                            <tr>
                                <th>E-mail</th>
                                <th>{t.users.fields.firstname}</th>
                                <th>{t.users.fields.lastname}</th>
                                <th>{t.user.ofa_missing}</th>
                                <th>{t.user.ofa_completed}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {users.map((u)=>(
                                <tr key={u.user_id} className="pointer" onClick={()=>setSelectedUser(u.user_id)}>
                                    <td>{u.email}</td>
                                    <td>{u.firstname}</td>
                                    <td>{u.lastname}</td>
                                    <td className="text-danger">{u.missing_subjects.map(s => s.subject_name).join(', ')}</td>
                                    <td className="text-success">{u.recovered_subjects.map(s => s.subject_name).join(', ')}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                }
                {canLoadMore &&
                    <button className="secondary mx-auto d-block" disabled={isLoading} onClick={()=>loadUsers(users.length)}>{t.ofa.load_more}</button>
                }
            </Modal.Body>
        </Modal>
        <ConfirmModal props={{
            show: showConfirmNotify,
            title: t.ofa.notify_users,
            text: t.ofa.notify_confirm_text,
            onConfirm: handleNotifyUsers,
            onClose: ()=>setShowConfirmNotify(false),
            confirmCta: t.ofa.notify_users,
            closeCta: t.modals.abort
        }} />
        {selectedUser ?
            <UserModal userId={selectedUser} onCloseModal={()=>setSelectedUser(null)} />
        : null}
        </>
    )
}
